const adaptReaction = (data: ICommentReaction): CommentReaction => ({
	id: data.id,
	reaction: data.reaction,
	name: data.name
});

const adaptReply = (data: ICommentReply): CommentReply => ({
	id: data.id,
	socialPost: data.social_post,
	body: data.body,
	user: data.user,
	userName: data.user_name ?? null,
	commentDate: data.comment_date,
	reactions: (data.reactions ?? []).map(adaptReaction)
});

export const adaptComment = (data: IComment): Comment => ({
	id: data.id,
	socialPost: data.social_post,
	body: data.body,
	user: data.user,
	userName: data.user_name ?? null,
	parentComment: data.parent_comment,
	commentDate: data.comment_date,
	commentReplies: (data.comment_replies ?? []).map(adaptReply),
	reactions: (data.reactions ?? []).map(adaptReaction)
});

export const adaptComments = (data: IComment[]): Comment[] => {
	return data.map(adaptComment);
};
